import * as React from "react"
import { useCallback } from "react"
import MaterialIcons from "react-native-vector-icons/MaterialIcons"
import { QRCodeScanner } from "../../qr-code-scanner/qr-code-scanner"
import { Actionsheet } from "../../actionsheet/actionsheet"
import { Appearance, Dimensions, ViewStyle } from "react-native"
import { Icon, useDisclose } from "native-base"
import { Input, InputProps } from "../input"
import { observer } from "mobx-react-lite"

export interface QrInputProps extends InputProps {
  //
}

const QR_INFO: ViewStyle = {
  flex: 0,
  height: 0
}

/**
 * Describe your component here
 */
export const QrInput = observer(function QrInput(props: QrInputProps) {
  const {
    colorScheme = Appearance.getColorScheme(),
    isDisabled, onChangeText,
    ...rest
  } = props

  const { isOpen, onOpen, onClose } = useDisclose()

  const onReadQr = useCallback(async ({ data }) => {
    await onClose()
    onChangeText(data)
  }, [onChangeText, onClose])

  return (
    <>
      <Input
        colorScheme={colorScheme}
        isDisabled={isDisabled}
        onChangeText={onChangeText}
        InputRightElement={(
          <Icon as={<MaterialIcons name="qr-code-scanner" />} testID={`${(rest.testID || "")}-qr-input`}
                size={"24px"} mr={"9px"} textAlign="center" backgroundColor={rest.backgroundColor} color="#666666"
                disabled={isDisabled}
                onPress={onOpen}
          />
        )}
        {...rest}
      />
      <Actionsheet
        colorScheme={colorScheme}
        isOpen={isOpen}
        onClose={onClose}
        title="Scan QR"
        actionsheetStyle={{ minHeight: Dimensions.get("window").width + 54 }}
      >
        <QRCodeScanner
          onRead={onReadQr}
          showMarker
          cameraProps={{ ratio: '1:1', autoFocus: "on" }}
          topViewStyle={QR_INFO}
          bottomViewStyle={QR_INFO}
          fadeIn={false}
        />
      </Actionsheet>
    </>
  )
})
